import { render, staticRenderFns } from "./Recaptcha.vue?vue&type=template&id=cc3a2c70"
import script from "./Recaptcha.vue?vue&type=script&lang=js"
export * from "./Recaptcha.vue?vue&type=script&lang=js"
import style0 from "./Recaptcha.vue?vue&type=style&index=0&id=cc3a2c70&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports